import { afterNextRender, ChangeDetectionStrategy, Component, ElementRef, signal, viewChild } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideChevronDown } from '@ng-icons/lucide';
import { HlmDialogDescription, HlmDialogTitle } from '@spartan-ng/helm/dialog';
import { LicencesRightsContent } from './licences-rights-content';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [HlmDialogDescription, HlmDialogTitle, NgIcon, LicencesRightsContent],
    providers: [provideIcons({ lucideChevronDown })],
    selector: 'app-licences-rights-dialog',
    template: `
        <div class="min-w-0 pr-8">
            <h2 class="text-lg font-semibold" hlmDialogTitle>Licences and Rights</h2>
            <p class="mt-1 text-sm text-muted-foreground" hlmDialogDescription>
                Credits, ownership, and community-project notice.
            </p>
        </div>

        <div class="relative flex max-h-[min(65vh,36rem)] min-h-0 flex-1 flex-col">
            <div
                class="flex-1 overflow-y-auto text-sm leading-6 text-foreground"
                #scrollContainer
                (scroll)="checkScrollPosition()">
                <app-licences-rights-content />
            </div>

            @if (scrollable()) {
                <button
                    class="pointer-events-auto absolute bottom-0 left-1/2 z-10 flex -translate-x-1/2 cursor-pointer items-center justify-center rounded-full border border-border bg-background/90 p-2 shadow-md backdrop-blur-sm transition-all hover:bg-muted active:scale-95"
                    (click)="scrollDown()">
                    <ng-icon class="size-3.5 animate-bounce" name="lucideChevronDown" />
                </button>
            }
        </div>
    `,
})
export class LicencesRightsDialog {
    private readonly scrollContainerRef = viewChild.required<ElementRef<HTMLElement>>('scrollContainer');

    protected readonly scrollable = signal(false);

    constructor() {
        afterNextRender(() => {
            this.checkScrollPosition();
        });
    }

    protected checkScrollPosition(): void {
        const el = this.scrollContainerRef().nativeElement;

        this.scrollable.set(
            el.scrollHeight > el.clientHeight && el.scrollTop + el.clientHeight < el.scrollHeight - 10
        );
    }

    protected scrollDown(): void {
        const el = this.scrollContainerRef().nativeElement;

        el.scrollTo({ behavior: 'smooth', top: el.scrollHeight });
    }
}
